@import "../shared.css";

:host {
	display: flex;
	position: relative;
	max-width: 100vw;
	background-color: rgb(var(--smoothly-input-background));
	box-sizing: border-box;
	min-height: var(--input-min-height);
}
:host .smoothly-date-placeholder {
	display: none;
}
:host:not([always-show-guide]):not(:focus-within):not(.has-text) .smoothly-date-placeholder {
	opacity: 0.5;
	display: block;
}

:host:not([always-show-guide]):not(:focus-within):not(.has-text) smoothly-date-text {
	visibility: hidden;
}

:host>.label {
	left: var(--input-padding-side);
}
:host[show-label] > .smoothly-date-placeholder,
:host[show-label] > smoothly-date-text {
	margin-inline: var(--input-padding-side);
	margin-block: var(--input-value-padding-top) var(--input-value-padding-bottom);
}
:host:not([show-label]) > .smoothly-date-placeholder,
:host:not([show-label]) > smoothly-date-text {
	margin-inline: var(--input-padding-side) auto;
	margin-block: auto;
}
:host:not([readonly]) {
	cursor: pointer;
}

:host[disabled] {
	cursor: not-allowed;
}

:host>smoothly-calendar {
	position: absolute;
	z-index: 20;
	top: 4rem;
	background-color: rgb(var(--smoothly-input-background));
	min-width: 18rem;
	max-width: 22rem;
}

:host>smoothly-calendar::before {
	content: "";
	position: absolute;
	left: 2rem;
	top: -0.55rem;
	z-index: 9;
	transform: rotate(45deg);
	width: 1rem;
	height: 1rem;
	background-color: rgb(var(--smoothly-input-background));
	border-top: 1px solid rgb(var(--smoothly-input-border));
	border-left: 1px solid rgb(var(--smoothly-input-border));
}

:host>.smoothly-icons {
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-left: auto;
}
:host>.smoothly-icons>.smoothly-invalid {
	display: none;
	padding: 0.5rem;
}
:host[invalid]>.smoothly-icons>.smoothly-invalid {
	display: flex;
}
